import emitter from "tiny-emitter/instance";

const Bus = {
    $emit: (event, opts) => {
        emitter.emit(event, opts);
    },
    $on: (event, handler) => {
        emitter.on(event, handler);
    },
    $off: (event, handler) => {
        emitter.off(event, handler);
    }
};


export { Bus };